const handler = (error, context, router) => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    // console.log(error.response.data)
    // console.log(error.response.status)
    // console.log(error.response.headers)
    // const notification = {
    //   type: 'error',
    //   code: error.response.errors[0].code,
    //   message: error.response.errors[0].title
    // }
    console.log('error.response', Object.assign({}, error))
    if (
      Array.isArray(error.response.data) &&
      error.response.data[0]['errors']
    ) {
      let errorsArray = error.response.data[0]['errors']
      errorsArray.forEach(item => {
        context.dispatch(
          'NotificationStore/add',
          { type: 'error', message: item.code + ' - ' + item.title },
          { root: true }
        )
      })
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log('error.request', error)

    context.dispatch(
      'NotificationStore/add',
      { type: 'error', message: error.message },
      { root: true }
    )
  } else {
    // Something happened in setting up the request that triggered an Error
    //console.log('else Error', error.message)
    context.dispatch(
      'NotificationStore/add',
      { type: 'error', message: error.message },
      { root: true }
    )
    console.error(Object.assign({}, error))
  }
  //console.log(error.config)
}

export default {
  handler
}
